// Chakra imports
import { Flex, Img, Text, useColorModeValue } from '@chakra-ui/react';

// Custom components
import { HorizonLogo } from 'components/icons/Icons';
import { HSeparator } from 'components/separator/Separator';
import { useNavigate } from 'react-router-dom';

export function SidebarBrand(props) {
  const { mini, hovered } = props;
  //   Chakra color mode
  let logoColor = useColorModeValue('navy.700', 'white');

  const navigate = useNavigate();

  return (
    <Flex alignItems="center" flexDirection="column">
      <Img
        src='/logo8.png'
        h='auto'
        w="160px"
        mb="32px"
        onClick={() => navigate('/admin/dashboard/overview')}
        color={logoColor}
        cursor="pointer"
        display={
          mini === false
            ? 'block'
            : mini === true && hovered === true
              ? 'block'
              : 'none'
        }
      />
      <Text
        display={
          mini === false
            ? 'none'
            : mini === true && hovered === true
              ? 'none'
              : 'block'
        }
        fontSize={'30px'}
        fontWeight="800"
        color={logoColor}
      >
        H
      </Text>
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
